<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span>COPYRIGHT &copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <span>Dynamic Development Studio</span>
          <span class="hidden sm:inline-block">, All rights Reserved</span>
        </p>
        <span class="md:flex hidden items-center">
            <span>v{{ appVersion }}</span>
        </span>
    </footer>
</template>

<script>
import { version } from '../../../package.json';

export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  },
  data () {
    return {
      appVersion: version
    }
  }
}
</script>
